import * as React from "react";

import { Batch8NewFooter } from "./batch8NewFooter/Batch8NewFooter";
import { FooterProps } from "./types";

export const Footer: React.FC<FooterProps> = (props) => {
  return (
    <div className="w-full">
      <Batch8NewFooter {...props} />
    </div>
  );
};
